import { createAction } from 'typesafe-actions'
import { TradeOrderSideEnum } from '@sparling/financial-common'

export const setAuthToken = createAction('SET_AUTH_TOKEN')<string>()
export const unsetAuthToken = createAction('UNSET_AUTH_TOKEN')<void>()
export const changeOrderSide = createAction('CHANGE_ORDER_SIDE')<TradeOrderSideEnum>()
export const setAuth2FAToken = createAction('SET_AUTH_2FA_TOKEN')<string>()
export const unsetAuth2FAToken = createAction('UNSET_AUTH_2FA_TOKEN')<void>()
export const redirectTo = createAction('REDIRECT_TO')<string | null>()
